// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"ecb3249a","488":"e5ce2be5","977":"fc216db9"}[chunkId] + ".chunk.js";
};